/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { closeDialog as closeDialogAction, updateDialog as updateDialogAction } from '@Containers/Dialogs/DialogsActions';
import { REDUCER_KEY_RS } from '@Pages/RetroSynthesis/RetroSynthesisProjects/constants';
import SimilaritySearchDialog from '@Pages/RetroSynthesis/SimilaritySearch/SimilaritySearchDialog';
import { REDUCER_KEY_SIMILARITY_SEARCH } from '@Pages/RetroSynthesis/SimilaritySearch/constants';
import {
  cleanState as cleanStateAction,
  fetchSimilaritySearch as fetchSimilaritySearchAction,
  loadSimilaritySearchResults as loadSimilaritySearchResultsAction,
  submitSimilarSubstance as submitSimilarSubstanceAction,
} from '@Pages/RetroSynthesis/SimilaritySearch/actions';
import { typeOfRsSimilaritySearchDialog } from '@Containers/Dialogs/DialogsMapperConstants';
import { onSimilarSubstanceSubmit } from '@Pages/RetroSynthesis/RetroSynthesisProjects/analytics';

export const openSimilaritySearchDialog = (project) => {
  return updateDialogAction({
    id: typeOfRsSimilaritySearchDialog,
    typeOfRsSimilaritySearchDialog,
    dialogType: typeOfRsSimilaritySearchDialog,
    project,
  });
};

function SimilaritySearchDialogContainer({
  fetchSimilaritySearch,
  loadSimilaritySearchResults,
  closeDialog,
  cleanState,
  submitSimilarSubstance,
  project,
  isSimilarityLoading,
  isResultsLoading,
  databaseId,
  reactions,
  totalItems,
  error,
}) {
  const history = useHistory();
  useEffect(() => {
    fetchSimilaritySearch(project);
    return () => {
      cleanState();
    };
  }, []);

  useEffect(() => {
    if (totalItems > 0 && reactions && reactions.length === 0) {
      loadSimilaritySearchResults();
    }
  }, [totalItems, reactions]);

  return (
    <SimilaritySearchDialog
      title="Please select a substance for synthesis planning"
      onCancel={() => closeDialog({ id: typeOfRsSimilaritySearchDialog })}
      onLoadMore={() => loadSimilaritySearchResults()}
      similarResults={reactions}
      isSimilarityLoading={isSimilarityLoading}
      isResultsLoading={isResultsLoading}
      totalItems={totalItems}
      error={error}
      onSubmitSubstance={async (substance) => {
        await submitSimilarSubstance({ project, substance, databaseId, location: history.location });
        onSimilarSubstanceSubmit(project);
        closeDialog({ id: typeOfRsSimilaritySearchDialog });
      }}
    />
  );
}

SimilaritySearchDialogContainer.propTypes = {
  fetchSimilaritySearch: PropTypes.func,
  loadSimilaritySearchResults: PropTypes.func,
  closeDialog: PropTypes.func,
  cleanState: PropTypes.func,
  submitSimilarSubstance: PropTypes.func,
  project: PropTypes.object,
  isSimilarityLoading: PropTypes.bool,
  isResultsLoading: PropTypes.bool,
  reactions: PropTypes.array,
  totalItems: PropTypes.number,
  error: PropTypes.object,
  databaseId: PropTypes.string,
};

function mapStateToProps(state) {
  const { isSimilarityLoading, isResultsLoading, resultPayload, reactions, totalItems, error } = state.getIn([
    REDUCER_KEY_RS,
    REDUCER_KEY_SIMILARITY_SEARCH,
  ]);
  const { databaseId } = resultPayload || {};
  return {
    isSimilarityLoading,
    isResultsLoading,
    databaseId,
    reactions,
    totalItems,
    error,
  };
}

const mapDispatchToProps = {
  fetchSimilaritySearch: fetchSimilaritySearchAction,
  loadSimilaritySearchResults: loadSimilaritySearchResultsAction,
  submitSimilarSubstance: submitSimilarSubstanceAction,
  closeDialog: closeDialogAction,
  cleanState: cleanStateAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(SimilaritySearchDialogContainer);
